import gql from 'graphql-tag';

export default gql`
  mutation removeManyFileMutation($ids: [MongoID]!) {
    removeManyFileMutation(ids: $ids) {
      message
      title
    }
  }
`;
